// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import './assets/dist/css/style.css'

Vue.config.productionTip = false;

Sentry.init({
  Vue,
  dsn: "https://79e0ccf572de4cbbabb0b19a95140ad1@o243225.ingest.sentry.io/6618216",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "acc-www.testjewerkgeluk.nl", "www.testjewerkgeluk.nl", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  logErrors: true,
  template: '<App/>',
  components: {App}
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js